<template>
  <b-input-group>
    <b-input
      type="text"
      :state="state"
      :disabled="disabled"
      v-mask="'###.###.###-##'"
      v-model="cpf"
      @input="evOnCPFInput"
      @change="evOnCPFChange"
    />
    <b-form-invalid-feedback> CPF inválido </b-form-invalid-feedback>
  </b-input-group>
</template>

<script>
import { numbersOnly } from "../../lib/format";

export default {
  name: "BInputCPF",

  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      loading: false,
      state: null,
      cpf: "",
    };
  },

  watch: {
    value() {
      this.cpf = this.value;
    },
  },

  methods: {
    async evOnCPFInput(value) {
      this.$emit("input", value);
    },

    async evOnCPFChange(value) {
      this.$emit("change", value);
      this.validate();
    },

    validate() {
      let valid = false;

      try {
        let cpf = numbersOnly(this.cpf).split("");

        if (cpf.length !== 11) return;

        //000.000.000-00 ... 999.999.999-99
        if ([...new Set(cpf)].length == 1) return;

        let a2 = cpf.pop();
        let a1 = cpf.pop();

        cpf = cpf.reverse();

        let v1 = 0;
        let v2 = 0;

        for (let i = 0; i < cpf.length; i++) {
          v1 = v1 + parseInt(cpf[i]) * (9 - (i % 10));
          v2 = v2 + parseInt(cpf[i]) * (9 - ((i + 1) % 10));
        }

        v1 = (v1 % 11) % 10;
        v2 = v2 + v1 * 9;
        v2 = (v2 % 11) % 10;

        if (a1 != v1 || a2 != v2) return;

        valid = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.state = valid ? null : false;
      }
    },
  },
};
</script>

<style>
</style>
